export default axios => ({
  getTags(params) {
    return axios.get('/tags', {params})
  },
  getTagsTypes(params) {
    return axios.get('/tags-types', {params})
  },
});